import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ElementRef, Input, input, OnDestroy } from '@angular/core';
import { EnpsSubscriber } from '@common/utils/enps-subscriber';
import { Subscription } from 'rxjs';

@Component({
    template: '',
})
export class EnpsComponent extends EnpsSubscriber implements OnDestroy {
    @Input() public isNewRecord: boolean = false;

    required = input(false, {
        transform: coerceBooleanProperty,
    });
    public static visualStatesCollection: { [id: string]: unknown } = {};

    public get visualState(): unknown {
        if (this._id) {
            if (!EnpsComponent.visualStatesCollection[this._id]) {
                EnpsComponent.visualStatesCollection[this._id] = {};
            }
            return EnpsComponent.visualStatesCollection[this._id];
        }
        return null;
    }

    public set visualState(s: unknown) {
        if (this._id) {
            EnpsComponent.visualStatesCollection[this._id] = s;
        }
    }

    private _id: string = null;
    @Input()
    public get id(): string {
        return this._id;
    }
    public set id(v: string) {
        if (this._id) {
            delete EnpsComponent.visualStatesCollection[this._id];
        }

        this._id = v;
        if (this._id && !EnpsComponent.visualStatesCollection[this._id]) {
            EnpsComponent.visualStatesCollection[this._id] = {};
        }
    }

    ngOnDestroy() {
        this.removeAllSubscriptions();
        for (const p of Object.keys(this)) {
            if (this[p] instanceof Subscription || this[p] instanceof EnpsComponent || this[p] instanceof ElementRef) {
                // console.log("set " + this.constructor.name + "." + p + " to null");
                this[p] = null;
            }
        }
        this.subscriptions = new Subscription();
    }
}
